export default __webpack_public_path__ + "images/header-profile-skin-1.png";